{
  "fr": {
    "select": {
      "actions": {
        "clear": "Effacer",
        "filterProject": "Filtrer sur Projet",
        "filterUnit": "Filtrer sur Unité",
        "noResults": "Aucun résultat",
        "noResultsFor": "Aucun résultat pour {search}",
        "reset": "Réinitialiser",
        "selectCategory": "Sélectionnez Catégorie",
        "selectUnit": "Sélectionner l'unité",
        "setToday": "Aujourd'hui",
        "startTyping": "Commencez à taper pour rechercher"
      },
      "groups": {
        "customers": "Clients",
        "employees": "Collègues"
      },
      "labels": {
        "allUnits": "Toutes les unités",
        "contact": "Contact",
        "without": "Sans",
        "withoutContact": "Sans personne de contact"
      },
      "placeholders": {
        "contact": "Cherchez une personne, ou choisissez 'sans'..."
      }
    }
  }
}
